import React from 'react';
import ButtonContainer from '../containers/ButtonContainer';

export const AddButton = (props) => (
    <ButtonContainer {...props} icon="plus-circle" />
);

export const BackButton = (props) => (
    <ButtonContainer {...props} icon="angle-left" />
);

export const NextButton = (props) => (
    <ButtonContainer {...props} icon="angle-right" />
);

export const EditButton = (props) => (
    <ButtonContainer {...props} icon="pencil" />
);

export const SaveButton = (props) => (
    <ButtonContainer {...props} icon="save" />
);

export const OkButton = (props) => (
    <ButtonContainer {...props} icon="check" />
);

export const CancelButton = (props) => (
    <ButtonContainer {...props} icon="ban" />
);

export const DeleteButton = (props) => (
    <ButtonContainer {...props} icon="trash" />
);

export const SendButton = (props) => (
    <ButtonContainer {...props} icon="paper-plane" />
);

export const DownloadButton = (props) => (
    <ButtonContainer {...props} icon="download" />
);

export const CloseButton = (props) => (
    <ButtonContainer {...props} icon="times-circle" />
);

export const Button = (props) => (
    <ButtonContainer {...props} />
);

